import Services from '../Service'

class AdminDashboardService extends Services {
  constructor() {
    super()
    this.resource = 'admin/dashboard'
  }

  /** Resumo do painel: KPIs, série e moeda — tudo menos o ranking. */
  async getDashboard(params) {
    return await this.getAPI(this.resource, params)
  }

  /**
   * Ranking de itens, em requisição própria: é a consulta mais cara do painel
   * e não pode segurar o resto da tela.
   */
  async getTopItens(params) {
    return await this.getAPI(this.resource + '/itens', params)
  }

  /**
   * Ranking COMPLETO, paginado — a tela /admin/relatorios/itens. Aceita page,
   * per_page, sort e search além do recorte de período/filial.
   */
  async getRankingItens(params) {
    return await this.getAPI(this.resource + '/ranking', params)
  }
}

export default new AdminDashboardService()
